"use strict";

const root = require('bunsen/helpers/windowCheck');
const tracking = require('dibs-tracking');
const mapValues = require('lodash.mapvalues');
const querystring = require('querystring');
const tokenReplace = require('dibs-token-replace');

const pinterest = require('../utils/social/pinterest');
const twitter = require('../utils/social/twitter');

const FACEBOOK = 'facebook';
const PINTEREST = 'pinterest';
const TWITTER = 'twitter';
const ENVELOPE = 'envelope';
const EMAIL = 'email';

const types = [FACEBOOK, PINTEREST, TWITTER, ENVELOPE, EMAIL];

/**
 * Fills in an object of tokenStrings
 *
 * @param {object} copy   - copy for options
 * @param {object} tokens - tokens to fill in the copy
 * @returns {object}
 * @private
 */
function _getOptions(copy, tokens) {
    if (!copy) {
        return {};
    }

    tokens = tokens || {};
    return mapValues(copy, (tokenString) => {
        return tokenReplace(tokenString, tokens);
    });
}

/**
 * Fires tracking
 */
function fireTracking(type, url, options) {
    if (type === EMAIL || type === ENVELOPE) {
        tracking.trackEvent({
            label: `share ${options.shared}`,
            category: 'email a friend',
            action: 'email a friend initiated'
        });
    } else {
        tracking.trackEvent({
            label: url,
            category: 'share',
            action: options.page
        });
        tracking.trackSocial({
            name: type,
            event: 'share' + (type === FACEBOOK ? ' intent' : ''),
            'opt_target': url
        });
    }
}

/**
 * Shares on facebook
 *  (Note: setup root.FB.ui by requiring /social/facebook.js in the entry file)
 *
 * @param {FluxContext} ac
 * @param {string} image    - the image to share
 * @param {function} done   - called after window is closed
 *
 * @param {string} [url]    - the url to share
 * @param {object} [copy]
 * @param {string} [copy.title]
 * @param {string} [copy.caption]
 * @param {string} [copy.description]
 * @param {object} [tokens] - tokens to fill in the copy
 */
function shareViaFacebook(ac, {image, url, copy, tokens}, done) {
    if (root.FB && root.FB.ui && image) {
        // set base options
        const options = Object.assign({
            method: 'stream.share',
            href: url || root.location.href,
            image

        // check copy for title, caption and description for post
        }, _getOptions(copy, tokens));


        // Opens facebook in new window
        root.FB.ui(options, done);
        return;
    }

    done();
}

/**
 * Shares on pinterest
 *
 * @param {FluxContext} ac
 * @param {string} image    - the image to share
 * @param {function} done   - called after window is closed
 * @param {string} [url]    - the url to share
 * @param {object} [copy]
 * @param {string} [copy.description]
 * @param {object} [tokens] - tokens to fill in the copy
 */
function shareViaPinterest(ac, {image, url, copy, tokens}, done) {
    if (image) {
        // set base options
        const options = Object.assign({
            pinterestWindow: pinterest.openWindow(),
            url: url || root.location.href,
            media: image

        // check copy for description for post
        }, _getOptions(copy, tokens));

        // Opens pinterest in new window
        pinterest.pin(options).then(done);
        return;
    }

    done();
}

/**
 * Shares on twitter
 *
 * @param {FluxContext} ac
 * @param {function} done   - called after window is closed
 * @param {string} [url]
 * @param {object} [copy]
 * @param {string} [copy.text]
 * @param {object} [tokens] - tokens to fill in the copy
 */
function shareViaTwitter(ac, {url, copy, tokens}, done) {
    const options = Object.assign({
        url
        // check copy for text for tweet
    }, _getOptions(copy, tokens));

    // Opens twitter in new window
    twitter.openWindow(options).then(done);
}

/**
 * Opens mail for sharing via email
 * @param {FluxContext} ac
 * @param {function} done       - called after window is opened
 * @param {object} [copy]
 * @param {string} [copy.subject]
 * @param {string} [copy.body]
 * @param {object} [tokens]
 */
function shareViaEmail(ac, {copy, tokens}, done) {
    // check copy for subject and body of email
    root.location.href = 'mailto:?' + querystring.stringify(_getOptions(copy, tokens));
    done();
}


/**
 * Given a type, calls the appropriate share action
 *
 * @param {FluxContext} ac
 * @param {function} done
 * @param {object} payload
 * @param {string} payload.type
 * @param {object} payload.copy
 * @param {string} payload.image
 * @param {object} payload.tokens
 */
function shareContent(ac, payload, done) {
    payload = payload || {};
    const {type, tokens, image, url} = payload;
    const copy = payload.copy || {};

    if (payload.tracking && payload.tracking.page && payload.tracking.shared) {
        fireTracking(type, url, payload.tracking);
    }

    switch (type) {
        case FACEBOOK:
            ac.executeAction(shareViaFacebook, {copy: copy.facebook, tokens, image, url}, done);
            break;

        case PINTEREST:
            ac.executeAction(shareViaPinterest, {copy: copy.pinterest, tokens, image, url}, done);
            break;

        case TWITTER:
            ac.executeAction(shareViaTwitter, {copy: copy.twitter, tokens, image, url}, done);
            break;

        case ENVELOPE:
        case EMAIL:
            ac.executeAction(shareViaEmail, {copy: copy.email, tokens}, done);
            break;

        default:
            done();
    }
}

module.exports = {
    shareViaFacebook,
    shareViaPinterest,
    shareViaTwitter,
    shareViaEmail,
    shareContent,
    types
};



// WEBPACK FOOTER //
// ./assets/js/global/actions/shareActions.es.js